
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const uomService = {

    getAll: async (filters = {}, branchId) => {
    try {
      const params = { ...filters };
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(ENDPOINTS.UOM.GET_ALL, { params });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch UOM list:", error);
      throw error;
    }
  },

  getCategories: async () => {
    try {
      const response = await apiClient.get(ENDPOINTS.UOM.GET_CATEGORIES);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch UOM categories:", error);
      throw error;
    }
  },

  create: async (payload) => {
    try {
      const response = await apiClient.post(ENDPOINTS.UOM.CREATE, payload);
      return response.data;
    } catch (error) {
      console.error("Failed to create UOM:", error);
      throw error;
    }
  },

  update: async (id, payload) => {
    try {
      const response = await apiClient.put(ENDPOINTS.UOM.UPDATE(id), payload);
      return response.data;
    } catch (error) {
      console.error(`Failed to update UOM ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.UOM.DELETE(id));
      return response.data;
    } catch (error) {
      console.error(`Failed to delete UOM ${id}:`, error);
      throw error;
    }
  },

  // Category CRUD methods
  getAllCategories: async (branchId) => {
    try {
      const params = {};
      if (branchId) params.branchId = branchId;
      const response = await apiClient.get(ENDPOINTS.UOM_CATEGORY.GET_ALL, { params });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch UOM categories:", error);
      throw error;
    }
  },

  createCategory: async (payload) => {
    try {
      const response = await apiClient.post(ENDPOINTS.UOM_CATEGORY.CREATE, payload);
      return response.data;
    } catch (error) {
      console.error("Failed to create UOM category:", error);
      throw error;
    }
  },

  updateCategory: async (id, payload) => {
    try {
      const response = await apiClient.put(ENDPOINTS.UOM_CATEGORY.UPDATE(id), payload);
      return response.data;
    } catch (error) {
      console.error(`Failed to update UOM category ${id}:`, error);
      throw error;
    }
  },

  deleteCategory: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.UOM_CATEGORY.DELETE(id));
      return response.data;
    } catch (error) {
      console.error(`Failed to delete UOM category ${id}:`, error);
      throw error;
    }
  },
};

export default uomService;
